<template>
  <NuxtLinkLocale
    :id="`${id}-link`"
    :data-testid="`${id}-link`"
    class="focus-visible:rounded-sm focus-visible:outline focus-visible:outline-offset"
    :to="to ? localePath(to) : undefined"
    :class="[
      { 'typography-text-xl': size == 'xl' },
      { 'typography-text-lg': size == 'lg' },
      { 'typography-text-base': size == 'base' },
      { 'typography-text-xs md:typography-text-sm': size == 'sm' },
      { 'typography-text-xs': size == 'xs' },
      {
        'text-primary-700 visited:text-primary-700 hover:text-primary-800 active:text-primary-700':
          variant == 'primary',
      },
      {
        'text-primary-900 visited:text-primary-900 hover:text-primary-800 active:text-primary-900':
          variant == 'secondary',
      },
      {
        'rounded-md bg-primary-500 px-4 py-2 font-medium text-white hover:bg-primary-800 focus:bg-primary-900':
          variant === 'navigation',
      },
      { underline },
    ]"
  >
    <slot />
  </NuxtLinkLocale>
</template>

<script setup lang="ts">
import type { LinkProps } from '~/components/ui/Link/types';

const localePath = useLocalePath();

withDefaults(defineProps<LinkProps>(), { size: 'base', underline: true, variant: 'primary' });
</script>
